import { render, staticRenderFns } from "./SelectOptionXTableFilter.vue?vue&type=template&id=28cba307"
import script from "./SelectOptionXTableFilter.vue?vue&type=script&lang=js"
export * from "./SelectOptionXTableFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports